<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <button type="button" class="link-voltar" @click="voltarAnterior">
          <i class="fa-solid fa-arrow-left"></i> Voltar à tela anterior
        </button>
        <h2>Dados completos do visitante</h2>
        <p v-if="dados && !permissoes.includes(256)" class="subtitulo">
          {{ dados.nomeAnfitriao ? "Anfitrião(ã): " + dados.nomeAnfitriao : "Solicitação #" + idVisita }}
        </p>
        <p v-else-if="dados" class="subtitulo">
          Visita em {{ formatarData(dados.dataVisita) }} —
          {{ dados.nomeAnfitriao ? "Anfitrião(ã): " + dados.nomeAnfitriao : "Solicitação #" + idVisita }}
        </p>
      </div>
    </div>

    <div class="margem container">
      <div v-if="carregando" class="bloco margem alinha-centro">
        <i class="fas fa-spinner fa-spin"></i> Carregando...
      </div>
      <div v-else-if="!dados" class="bloco margem alinha-centro">Solicitação não encontrada.</div>
      <div v-else-if="!permissoes.includes(256)" class="bloco margem card-dados">
        <div class="secao">
          <h3 class="secao-titulo"><i class="fa-solid fa-user-tie"></i> Anfitrião(ã)</h3>
          <dl class="lista-dados">
            <dt>Nome</dt>
            <dd>{{ dados.nomeAnfitriao || "—" }}</dd>
          </dl>
        </div>
        <div class="secao">
          <h3 class="secao-titulo"><i class="fa-solid fa-building"></i> Empresa</h3>
          <dl class="lista-dados">
            <dt>Empresa de origem</dt>
            <dd>{{ dados.empresaOrigem || "—" }}</dd>
          </dl>
        </div>
        <div v-for="(v, idx) in formVisitantes" :key="'v-rest-' + idx" class="secao">
          <h3 class="secao-titulo">
            <i class="fa-solid fa-user"></i>
            {{ formVisitantes.length > 1 ? "Visitante " + (idx + 1) : "Visitante" }}
          </h3>
          <dl class="lista-dados">
            <dt>Nome completo</dt>
            <dd>{{ v.nomeCompleto || "—" }}</dd>
          </dl>
        </div>
        <div class="secao">
          <h3 class="secao-titulo">Status do agendamento</h3>
          <span class="badge-status">{{ textoStatus(dados.statusAgendamento) }}</span>
        </div>
        <div class="acoes">
          <button type="button" class="btn-voltar" @click="voltarAnterior">
            <i class="fa-solid fa-arrow-left"></i> Voltar à tela anterior
          </button>
        </div>
      </div>
      <div v-else class="bloco margem">
        <p v-if="dados.cancelada" class="aviso-cancelada">
          Visita cancelada — os dados podem ser consultados, mas não é possível alterá-los aqui.
        </p>
        <p v-else-if="visitaPassadaSomenteLeitura" class="aviso-visita-passada">
          Data da visita já passou — os dados podem ser consultados, mas não é possível alterá-los pela web.
        </p>

        <div v-if="dados && podeEditarVisitantes" class="bloco margem card-visitante card-dados card-empresa-origem">
          <h3 class="secao-titulo">
            <i class="fa-solid fa-building"></i>
            Empresa do visitante
          </h3>
          <p class="empresa-ajuda fonte-menor fonte-fraca">
            Nome da empresa de origem — vale para todos os visitantes desta solicitação.
          </p>
          <template v-if="!editandoEmpresaOrigem">
            <p class="empresa-valor">{{ dados.empresaOrigem || "—" }}</p>
            <button type="button" class="btn-editar" @click="iniciarEdicaoEmpresaOrigem">
              <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
              Alterar empresa
            </button>
          </template>
          <div v-else class="form-edicao-visitante">
            <div class="campo-linha">
              <label for="empresa-origem-dcv">Nome da empresa</label>
              <input
                id="empresa-origem-dcv"
                v-model.trim="empresaOrigemRascunho"
                type="text"
                class="inp"
                maxlength="250"
                autocomplete="organization"
              />
            </div>
            <div class="barra-btns-empresa">
              <button type="button" class="btn-salvar" :disabled="salvandoEmpresaOrigem" @click="salvarEmpresaOrigem">
                <i v-if="salvandoEmpresaOrigem" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                {{ salvandoEmpresaOrigem ? "Salvando…" : "Salvar empresa" }}
              </button>
              <button type="button" class="btn-cancelar-edicao" :disabled="salvandoEmpresaOrigem" @click="cancelarEdicaoEmpresaOrigem">
                Cancelar
              </button>
            </div>
          </div>
        </div>

        <div v-for="(v, idx) in formVisitantes" :key="'v-' + idx" class="card-visitante card-dados">
          <div class="card-visitante-topo">
            <h3 class="secao-titulo">
              <i class="fa-solid fa-id-card"></i>
              {{ formVisitantes.length > 1 ? "Visitante " + (idx + 1) : "Visitante" }}
            </h3>
          </div>

          <template v-if="!editando">
            <dl class="lista-dados">
              <dt>Nome completo</dt>
              <dd>{{ v.nomeCompleto || "—" }}</dd>
              <dt>CPF ou RG</dt>
              <dd>{{ valorDocumentoUnicoVisitante(v) || "—" }}</dd>
              <dt>E-mail</dt>
              <dd>{{ v.email || "—" }}</dd>
              <dt>Telefone / WhatsApp</dt>
              <dd>{{ v.telefoneWhatsapp || "—" }}</dd>
            </dl>
          </template>
          <div v-else class="form-edicao-visitante">
            <div class="campo-linha">
              <label :for="'nv-' + idx">Nome completo</label>
              <input :id="'nv-' + idx" v-model.trim="v.nomeCompleto" type="text" class="inp" autocomplete="name" />
            </div>
            <div class="campo-linha">
              <label :for="'docv-' + idx">CPF ou RG</label>
              <input
                :id="'docv-' + idx"
                :value="valorDocumentoUnicoVisitante(v)"
                type="text"
                class="inp"
                autocomplete="off"
                @input="atualizarDocumentoVisitante(idx, $event.target.value)"
              />
            </div>
            <div class="campo-linha">
              <label :for="'ev-' + idx">E-mail (opcional)</label>
              <input :id="'ev-' + idx" v-model.trim="v.email" type="email" class="inp" autocomplete="email" />
            </div>
            <div class="campo-linha">
              <label :for="'tv-' + idx">Telefone / WhatsApp (opcional)</label>
              <input :id="'tv-' + idx" v-model.trim="v.telefoneWhatsapp" type="text" class="inp" autocomplete="tel" />
            </div>
          </div>
        </div>

        <div v-if="podeEditarVisitantes" class="barra-edicao">
          <template v-if="!editando">
            <button type="button" class="btn-editar" @click="iniciarEdicao">
              <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
              Corrigir dados do(s) visitante(s)
            </button>
          </template>
          <template v-else>
            <button type="button" class="btn-salvar" :disabled="salvando" @click="salvarVisitantes">
              <i v-if="salvando" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
              <i v-else class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
              {{ salvando ? "Salvando…" : "Salvar alterações" }}
            </button>
            <button type="button" class="btn-cancelar-edicao" :disabled="salvando" @click="cancelarEdicao">Cancelar</button>
          </template>
        </div>

        <div class="acoes">
          <router-link v-if="idVisita" :to="'/acesso/visita/' + idVisita + '/dados-completos-visita'" class="link-secundario">
            <i class="fa-solid fa-calendar-check"></i> Ver dados completos da visita
          </router-link>
          <button type="button" class="btn-voltar" @click="voltarAnterior">
            <i class="fa-solid fa-arrow-left"></i> Voltar à tela anterior
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import { isDataVisitaEstritamentePassada } from "@/utils/visita-data";
import { getPermissao } from "@/services/permissaoService";
import {
  aplicarDocumentoUnicoVisitante,
  normalizarVisitanteDocumentos,
  valorDocumentoUnicoVisitante,
} from "@/config/visitante-documentos";
import { textoStatus as textoStatusConfig } from "@/config/status-visita";

const toaster = createToaster({ position: "top-right" });

export default {
  name: "DadosCompletosVisitanteView",

  data() {
    return {
      dados: null,
      carregando: true,
      permissoes: [],
      editando: false,
      salvando: false,
      formVisitantes: [],
      editandoEmpresaOrigem: false,
      empresaOrigemRascunho: "",
      salvandoEmpresaOrigem: false,
    };
  },

  computed: {
    idVisita() {
      return this.$route.params.id || null;
    },
    /** Destino se não houver histórico para router.back() (ex.: abertura direta do link). */
    voltarFallbackUrl() {
      return this.idVisita ? `/acesso/checklist/${this.idVisita}` : "/agenda";
    },
    visitaPassadaSomenteLeitura() {
      return !!(this.dados && !this.dados.cancelada && isDataVisitaEstritamentePassada(this.dados.dataVisita, this.dados.dataVisitaFim));
    },
    podeEditarVisitantes() {
      if (!this.dados || this.dados.cancelada) return false;
      return !isDataVisitaEstritamentePassada(this.dados.dataVisita, this.dados.dataVisitaFim);
    },
  },

  watch: {
    dados: {
      handler() {
        if (!this.editando) {
          this.sincronizarFormDoDados();
        }
      },
    },
    podeEditarVisitantes(val) {
      if (!val) {
        this.editando = false;
        this.editandoEmpresaOrigem = false;
      }
    },
  },

  async created() {
    this.permissoes = await getPermissao();
    this.carregar();
  },

  methods: {
    valorDocumentoUnicoVisitante,

    atualizarDocumentoVisitante(idx, valor) {
      aplicarDocumentoUnicoVisitante(this.formVisitantes[idx], valor);
    },

    textoStatus(s) {
      return textoStatusConfig(s);
    },

    voltarAnterior() {
      if (typeof window !== "undefined" && window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push(this.voltarFallbackUrl);
    },
    listaExibicao() {
      if (!this.dados?.listaVisitantes) return [];
      return this.dados.listaVisitantes;
    },
    sincronizarFormDoDados() {
      const list = this.listaExibicao();
      this.formVisitantes = list.map((v) => {
        const docs = normalizarVisitanteDocumentos(v);
        return {
        nomeCompleto: v.nomeCompleto || "",
        cpf: docs.cpf,
        rg: docs.rg,
        documentoRgCnh: docs.rg,
        email: v.email || "",
        telefoneWhatsapp: v.telefoneWhatsapp || "",
        visitanteId: v.visitanteId != null && v.visitanteId > 0 ? Number(v.visitanteId) : null,
      };
      });
    },
    iniciarEdicao() {
      if (!this.podeEditarVisitantes) {
        toaster.show("Não é possível alterar os dados desta visita.", { type: "warning" });
        return;
      }
      this.sincronizarFormDoDados();
      this.editando = true;
    },
    cancelarEdicao() {
      this.editando = false;
      this.sincronizarFormDoDados();
    },
    iniciarEdicaoEmpresaOrigem() {
      if (!this.podeEditarVisitantes) {
        toaster.show("Não é possível alterar os dados desta visita.", { type: "warning" });
        return;
      }
      this.empresaOrigemRascunho = String(this.dados?.empresaOrigem || "").trim();
      this.editandoEmpresaOrigem = true;
    },
    cancelarEdicaoEmpresaOrigem() {
      this.editandoEmpresaOrigem = false;
      this.empresaOrigemRascunho = "";
    },
    async salvarEmpresaOrigem() {
      if (!this.idVisita || this.salvandoEmpresaOrigem) return;
      if (!this.podeEditarVisitantes) {
        toaster.show("Não é possível alterar os dados desta visita.", { type: "warning" });
        return;
      }
      this.salvandoEmpresaOrigem = true;
      try {
        await solicitacaoVisitaService.atualizarEmpresaOrigem(this.idVisita, this.empresaOrigemRascunho);
        toaster.show("Empresa atualizada.", { type: "success" });
        this.editandoEmpresaOrigem = false;
        this.empresaOrigemRascunho = "";
        await this.carregar();
      } catch (err) {
        console.error(err);
        const msg = err?.response?.data?.message || "Não foi possível salvar a empresa.";
        toaster.show(typeof msg === "string" ? msg : "Erro ao salvar.", { type: "error" });
      } finally {
        this.salvandoEmpresaOrigem = false;
      }
    },
    formatarData(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return String(val);
      return d.toLocaleDateString("pt-BR");
    },
    async carregar() {
      if (!this.idVisita) {
        this.carregando = false;
        return;
      }
      this.carregando = true;
      try {
        this.dados = await solicitacaoVisitaService.obterPorId(this.idVisita);
        this.sincronizarFormDoDados();
      } catch (err) {
        console.error(err);
        toaster.show("Erro ao carregar dados.", { type: "error" });
      } finally {
        this.carregando = false;
      }
    },
    async salvarVisitantes() {
      if (!this.idVisita || this.salvando) return;
      if (!this.podeEditarVisitantes) {
        toaster.show("Não é possível alterar os dados desta visita.", { type: "warning" });
        return;
      }
      for (let i = 0; i < this.formVisitantes.length; i++) {
        const row = this.formVisitantes[i];
        if (!String(row.nomeCompleto || "").trim()) {
          const msg =
            this.formVisitantes.length > 1
              ? `Informe o nome completo do visitante ${i + 1}.`
              : "Informe o nome completo.";
          toaster.show(msg, { type: "warning" });
          return;
        }
      }
      this.salvando = true;
      try {
        const payload = this.formVisitantes.map((row) => ({
          nomeCompleto: row.nomeCompleto,
          cpf: row.cpf,
          rg: row.rg,
          documentoRgCnh: row.rg || row.documentoRgCnh,
          email: row.email,
          telefoneWhatsapp: row.telefoneWhatsapp,
          visitanteId: row.visitanteId,
        }));
        await solicitacaoVisitaService.atualizarVisitantes(this.idVisita, payload);
        toaster.show("Dados do visitante atualizados.", { type: "success" });
        this.editando = false;
        await this.carregar();
      } catch (err) {
        console.error(err);
        const msg = err?.response?.data?.message || "Não foi possível salvar. Tente novamente.";
        toaster.show(typeof msg === "string" ? msg : "Erro ao salvar.", { type: "error" });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.link-voltar {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--cor-primaria-forte);
  text-decoration: none;
  font-size: 0.95rem;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}
.link-voltar:hover {
  text-decoration: underline;
}
.subtitulo {
  margin-top: 0.25rem;
  font-size: 0.9rem;
  color: var(--cor-fonte-fraca);
}
.aviso-cancelada {
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background: var(--cor-cinza);
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
}
.aviso-visita-passada {
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-primaria-fraca);
  color: var(--cor-fonte);
  font-size: 0.9rem;
}
.card-dados {
  max-width: 720px;
  border-radius: 12px;
  border: 1px solid var(--cor-separador);
  padding: 1.5rem;
}
.secao {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--cor-separador);
}
.secao:last-of-type {
  border-bottom: none;
}
.badge-status {
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.95rem;
  background: var(--cor-cinza);
  color: var(--cor-fonte);
}
.card-visitante {
  max-width: 560px;
  border-radius: 12px;
  border: 1px solid var(--cor-separador);
  padding: 1.5rem;
  margin-bottom: 1rem;
}
.card-visitante-topo {
  margin-bottom: 0.75rem;
}
.secao-titulo {
  font-size: 1rem;
  margin-bottom: 0.75rem;
  color: var(--cor-fonte-forte);
}
.secao-titulo i {
  margin-right: 0.5rem;
}
.lista-dados {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 0.35rem 1rem;
  margin: 0;
  font-size: 0.95rem;
}
.lista-dados dt {
  color: var(--cor-fonte-fraca);
  font-weight: 500;
}
.lista-dados dd {
  margin: 0;
}
.form-edicao-visitante {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.campo-linha label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--cor-fonte-fraca);
  margin-bottom: 0.25rem;
}
.inp {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.6rem;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  font-size: 0.95rem;
  background: var(--cor-bg);
  color: var(--cor-fonte);
}
.barra-edicao {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1.25rem;
  max-width: 560px;
}
.btn-editar {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 1rem;
  border: 1px solid var(--cor-primaria);
  border-radius: 24px;
  background: transparent;
  color: var(--cor-primaria-forte);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-editar:hover {
  background: var(--cor-cinza2, rgba(0, 0, 0, 0.04));
}
.card-empresa-origem .empresa-ajuda {
  margin-bottom: 0.75rem;
}
.card-empresa-origem .empresa-valor {
  font-size: 1rem;
  color: var(--cor-fonte-forte);
  margin: 0 0 0.75rem 0;
  font-weight: 600;
}
.barra-btns-empresa {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  margin-top: 0.5rem;
}
.btn-salvar {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 24px;
  background: var(--cor-primaria);
  color: var(--cor-bg);
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
}
.btn-salvar:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.btn-cancelar-edicao {
  padding: 0.5rem 0.85rem;
  border: none;
  background: none;
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.acoes {
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}
.link-secundario {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--cor-primaria-forte);
  text-decoration: none;
  font-size: 0.95rem;
}
.link-secundario:hover {
  text-decoration: underline;
}
.btn-voltar {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--cor-primaria);
  color: var(--cor-bg);
  border: none;
  border-radius: 24px;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
}
.btn-voltar:hover {
  background: var(--cor-primaria-forte);
  color: var(--cor-bg);
}
</style>
